import React from 'react'
import {Form, Input} from "antd";

const RecipeFilter = () => {

    return(
        <React.Fragment>
            <Form.Item
                name={'createdBy'}
                label={'Oluşturan'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={'code'}
                label={'Reçete Kodu'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={'name'}
                label={'Reçete Adı'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
        </React.Fragment>
    )
}

export default RecipeFilter